export default __webpack_public_path__ + "bee9706578db2ef106884f2d3ff88342.svg";